export const TRANSLATION_KEYS = {
    authInvalidEmailFormat: "Auth##invalid email format",
    authRequired: "Auth##required"
} as const;
